import React from "react";

const Pagination = (props) => {
  const paginationItemLogic = () => {
    const cPage = parseInt(props.currentPage);
    if (props.totalPages <= 5) {
      return { start: 0, end: 5 };
    }else{
      if (cPage < 3) {
        return { start: 0, end: 5 };
      } else if (cPage >= 3 && cPage < props.totalPages - 2) {
        return { start: cPage - 3, end: cPage + 2 };
      } else return { start: props.totalPages - 5, end: props.totalPages };
    }
    
  };
  return (
    <div className="finderTable-pagination">
      <button
        className={`${
          props.currentPage < 2 ? "finderTable-paginate-disabled" : ""
        } finderTable-pagination-btn-first`}
        onClick={props.onPagination.first}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.5"
          height="17"
          viewBox="0 0 9.5 17">
          <g
            id="Group_19853"
            data-name="Group 19853"
            transform="translate(1474 2739.5) rotate(180)"
            opacity="0.4">
            <g
              id="Polygon_5"
              data-name="Polygon 5"
              transform="translate(1473.5 2722.5) rotate(90)"
              fill="transparent">
              <path
                d="M 15.84003067016602 8.5 L 1.159969449043274 8.5 L 8.5 0.7282029390335083 L 15.84003067016602 8.5 Z"
                stroke="none"
              />
              <path
                d="M 8.5 1.456395149230957 L 2.319929122924805 8 L 14.6800708770752 8 L 8.5 1.456395149230957 M 8.5 0 L 17 9 L 0 9 L 8.5 0 Z"
                stroke="none"
                fill="#0672cb"
              />
            </g>
            <line
              id="Line_1182"
              data-name="Line 1182"
              y2="17"
              transform="translate(1473.5 2722.5)"
              fill="none"
              stroke="#0672cb"
              strokeWidth="1"
            />
          </g>
        </svg>
      </button>
      <button
        className={`${
          props.currentPage < 2 ? "finderTable-paginate-disabled" : ""
        } finderTable-pagination-btn-prev`}
        onClick={props.onPagination.prev}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="17"
          viewBox="0 0 9 17">
          <g
            id="Polygon_6"
            data-name="Polygon 6"
            transform="translate(0 17) rotate(-90)"
            fill="transparent"
            opacity="0.4">
            <path
              d="M 15.84003067016602 8.5 L 1.159969449043274 8.5 L 8.5 0.7282029390335083 L 15.84003067016602 8.5 Z"
              stroke="none"
            />
            <path
              d="M 8.5 1.456395149230957 L 2.319929122924805 8 L 14.6800708770752 8 L 8.5 1.456395149230957 M 8.5 0 L 17 9 L 0 9 L 8.5 0 Z"
              stroke="none"
              fill="#0672cb"
            />
          </g>
        </svg>
        <span>{window.finderTable.dict.previous}</span>
      </button>
      <input
        className="finderTable-pagination-input"
        type="text"
        value={props.currentPage}
        onChange={props.onPagination.page}
      />
      <div className="finderTable-pagination-total-pages">
        {window.finderTable.dict.of} {props.totalPages}
      </div>
      <div className="finderTable-pagination-total-items">
        {[...Array(props.totalPages).keys()]
          .slice(paginationItemLogic().start, paginationItemLogic().end)
          .map((x, i) => {
            return (
              <button
                key={x}
                value={x + 1}
                name="page"
                className={`${
                  props.currentPage == x + 1
                    ? "finderTable-pagination-btn-active"
                    : ""
                } finderTable-pagination-btn-page`}
                onClick={props.onPagination.page}>
                {x + 1}
              </button>
            );
          })}
      </div>
      <button
        className={`${
          props.totalPages <= props.currentPage
            ? "finderTable-paginate-disabled"
            : ""
        } finderTable-pagination-btn-next`}
        onClick={props.onPagination.next}>
        <span>{window.finderTable.dict.next}</span>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9"
          height="17"
          viewBox="0 0 9 17">
          <g
            id="Polygon_4"
            data-name="Polygon 4"
            transform="translate(9) rotate(90)"
            fill="transparent">
            <path
              d="M 15.84003067016602 8.5 L 1.159969449043274 8.5 L 8.5 0.7282029390335083 L 15.84003067016602 8.5 Z"
              stroke="none"
            />
            <path
              d="M 8.5 1.456395149230957 L 2.319929122924805 8 L 14.6800708770752 8 L 8.5 1.456395149230957 M 8.5 0 L 17 9 L 0 9 L 8.5 0 Z"
              stroke="none"
              fill="#0672cb"
            />
          </g>
        </svg>
      </button>
      <button
        className={`${
          props.totalPages <= props.currentPage
            ? "finderTable-paginate-disabled"
            : ""
        } finderTable-pagination-btn-last`}
        onClick={props.onPagination.last}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="9.5"
          height="17"
          viewBox="0 0 9.5 17">
          <g
            id="Group_19852"
            data-name="Group 19852"
            transform="translate(-1464.5 -2722.5)">
            <g
              id="Polygon_5"
              data-name="Polygon 5"
              transform="translate(1473.5 2722.5) rotate(90)"
              fill="transparent">
              <path
                d="M 15.84003067016602 8.5 L 1.159969449043274 8.5 L 8.5 0.7282029390335083 L 15.84003067016602 8.5 Z"
                stroke="none"
              />
              <path
                d="M 8.5 1.456395149230957 L 2.319929122924805 8 L 14.6800708770752 8 L 8.5 1.456395149230957 M 8.5 0 L 17 9 L 0 9 L 8.5 0 Z"
                stroke="none"
                fill="#0672cb"
              />
            </g>
            <line
              id="Line_1182"
              data-name="Line 1182"
              y2="17"
              transform="translate(1473.5 2722.5)"
              fill="none"
              stroke="#0672cb"
              strokeWidth="1"
            />
          </g>
        </svg>
      </button>
    </div>
  );
};

export default Pagination;
